import type { Validator } from "@entrilia/shared/utilities/validators";
import { invalidResult, validResult } from "@entrilia/shared/utilities/validators";
import type { MeasureDescriptor } from "../../../../../../../../../api/types/svTypes.ts";

export const duplicateMeasureNameValidator = (
  measures: MeasureDescriptor[],
  currentName?: string
): Validator<string> => {
  return (value: string) => {
    if (
      measures.some((measure) => measure.name !== currentName && measure.caption.toLowerCase() === value.toLowerCase())
    ) {
      return invalidResult(`${value} Measure already exists`);
    }

    return validResult();
  };
};
